import {useEffect} from "react";

// use this hook to add some vendor script directly from React;
const useScript = (url: string): void => {
  useEffect(() => {
    const script = document.createElement("script");

    script.src = url;
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [url]);
};

export default useScript;
